<div class="loading-screen-wrapper">
  <app-dot-loader></app-dot-loader>
  <div class="loader__background"></div>
</div>
